import React from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Tu hijo explota en el supermercado y no sabés qué hacer sin que te mire todo el mundo', 'Cedés el límite por vergüenza y después lo ruminás toda la noche', 'Perdés el control, le gritás y la culpa te aplasta antes de que se duerma', 'Cada berrinche es diferente y nunca sabés si estás haciendo lo correcto', 'Probaste de todo y a los 10 minutos volvés a lo mismo de siempre', 'El domingo a la noche ya sabés que la semana viene igual que la anterior'];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-218">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(239,68,68,0.05),transparent_70%)] pointer-events-none" data-id="element-219"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-220">
        <FadeIn data-id="element-221">
          <h2 className="text-3xl md:text-5xl text-white mb-10 text-center leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-222">
            ¿Cuántos berrinches más <br className="hidden md:block" data-id="element-223" />
            <span className="text-premium-gold-luminous" data-id="element-224">
              vas a manejar sin un sistema?
            </span>
          </h2>

          <div className="mx-auto mb-12 text-gray-200 text-center space-y-6 text-base md:text-lg font-sans opacity-90" data-id="element-225">
            <p data-id="element-226">
              Sos un buen padre. Una buena madre. Amás a tu hijo con todo. Pero
              nadie te dijo que ibas a terminar el día sintiéndote peor que él.
            </p>
            <p data-id="element-227">
              Gritaste más de lo que querías. Cediste para que se callara. Y
              después vino la culpa.
            </p>
          </div>

          <div className="flex justify-center mb-12" data-id="element-228">
            <div className="bg-gradient-to-r from-red-500/10 via-red-500/20 to-red-500/10 border-y border-red-500/30 py-6 px-8 w-full max-w-2xl text-center" data-id="element-229">
              <p className="font-bold text-white uppercase tracking-[0.15em] text-lg md:text-2xl font-sans" data-id="element-230">
                No es falta de amor.
                <br className="md:hidden" data-id="element-231" />{' '}
                <span className="text-red-400" data-id="element-232">Es falta de un sistema.</span>
              </p>
            </div>
          </div>

          <div className="bg-navy-900/60 border border-white/10 rounded-3xl p-6 md:p-10 mb-12" data-id="element-233">
            <ul className="space-y-5" data-id="element-234">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-235">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-236" />
                  <span className="text-base md:text-lg text-white/90 font-sans leading-relaxed" data-id="element-237">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-238">
            <h3 className="text-2xl md:text-4xl text-premium-gold-luminous leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-239">
              ¿Y si este fuera el último berrinche que manejás sin herramientas?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};